import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ClienteProvider } from './context/ClienteContext'; 
import './styles/global.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ClienteProvider>         {/* ✅ Envolve toda a aplicação */}
        <App />
      </ClienteProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
